<script lang="ts"
        setup
>
const { data: page } = useErrorPage()
</script>

<template>
  <svg
    id="4ab60524-fc39-4f87-ab18-e44e377082c8"
    :data-name="page?.error?.['400']?.title"
    height="100%"
    viewBox="0 0 1003.96 687.01"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>
      {{ page?.error?.['400']?.title }}
    </title>
    <defs>
      <linearGradient
        id="f0a282d0-9b08-452c-9a6e-ab0cad214b10"
        gradientTransform="translate(29.55 152.11)"
        gradientUnits="userSpaceOnUse"
        x1="378.33"
        x2="378.33"
        y1="494.44"
        y2="91.8"
      >
        <stop
          offset="0"
          stop-color="gray"
          stop-opacity="0.25"
        />
        <stop
          offset="0.54"
          stop-color="gray"
          stop-opacity="0.12"
        />
        <stop
          offset="1"
          stop-color="gray"
          stop-opacity="0.1"
        />
      </linearGradient>
      <linearGradient
        id="b45dc65a-d934-4006-b8a5-a3a1dfbcc07e"
        gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
        x1="901.92"
        x2="901.92"
        xlink:href="#f0a282d0-9b08-452c-9a6e-ab0cad214b10"
        y1="733"
        y2="109"
      />
    </defs>
    <title>filing_system</title>
    <path
      d="M196,630.27c-4.29,9.21,1.85,19.15-.28,28.66-2.69,12-18.11,21.34-34.72,27.3s-35.16,9.58-51.35,16c-7,2.77-14.3,7.88-10.66,12.58,1.26,1.63,3.62,2.77,5.93,3.84,47.16,21.76,105.45,33.58,163.69,33.2,61.6-.41,121.92-14,183.47-12.44,79.38,2,156.16,29.06,234.66,21.26C720.06,757.34,751,747.9,783.45,742c47.72-8.67,97.91-9.54,147.33-12.39,37.11-2.14,79.52-7.69,97.25-28.55,12.82-15.08,7.44-35-10.62-47.77s-46.91-18.23-73.56-15.75c-14.33,1.33-28.57,4.78-42.9,3.41-8.32-.8-16-3.18-23.59-5.52-58.71-18.2-119.53-36.36-184.7-39-106-4.33-204.25,32.55-307.52,48.5-16.08,2.48-33.54,4.39-48.73.23-16-4.39-26.5-14.76-42.53-19.13-7.61-2.08-16.09-2.68-23.57-4.94-20.56-6.22-11-14.77-39.54-9C215.86,615.13,200.8,620,196,630.27Z"
      fill="currentColor"
      opacity="0.1"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M207.7,316.06S263.46,371.82,232,454.56s54,220.33,54,220.33-.92-.13-2.61-.43C168.81,654.24,111.91,523.27,175.59,426,199.26,389.79,218.7,347.36,207.7,316.06Z"
      fill="currentColor"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M207.7,316.06S263.46,371.82,232,454.56s54,220.33,54,220.33-.92-.13-2.61-.43C168.81,654.24,111.91,523.27,175.59,426,199.26,389.79,218.7,347.36,207.7,316.06Z"
      opacity="0.1"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M207.7,316.06s31.48,68.35,0,124.11-5.4,212.24,78.24,234.72"
      fill="none"
      stroke="#535461"
      stroke-miterlimit="10"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M108.39,541.58s63.63-10.13,69.43,46.89,122.34,64.93,122.34,64.93-.76.52-2.19,1.45C201.75,718,109.76,695.09,123.62,611.21,128.78,580,128.35,548.7,108.39,541.58Z"
      fill="currentColor"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M108.39,541.58s63.63-10.13,69.43,46.89,122.34,64.93,122.34,64.93-.76.52-2.19,1.45C201.75,718,109.76,695.09,123.62,611.21,128.78,580,128.35,548.7,108.39,541.58Z"
      fill="#f5f5f5"
      opacity="0.2"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M108.39,541.58s49.39,10.84,45.33,55.75,73.34,98.74,146.44,56.07"
      fill="none"
      stroke="#535461"
      stroke-miterlimit="10"
      transform="translate(-98.02 -109)"
    />
    <polygon
      fill="currentColor"
      points="676.74 564.63 153.31 564.63 153.31 237.66 220.25 237.66 247.79 271.68 676.74 271.68 676.74 564.63"
    />
    <polygon
      opacity="0.1"
      points="676.74 564.63 153.31 564.63 153.31 237.66 220.25 237.66 247.79 271.68 676.74 271.68 676.74 564.63"
    />
    <rect
      fill="#f1f1f4"
      height="390.14"
      transform="matrix(0.94, -0.34, 0.34, 0.94, -214.87, 95.51)"
      width="250.61"
      x="406.83"
      y="244.61"
    />
    <rect
      fill="#fff"
      height="16.66"
      transform="matrix(0.94, -0.34, 0.34, 0.94, -180.24, 53.77)"
      width="70.81"
      x="393.5"
      y="310.47"
    />
    <rect
      fill="#fff"
      height="15.27"
      transform="translate(-183.79 77.81) rotate(-19.65)"
      width="155.5"
      x="418.81"
      y="333.44"
    />
    <rect
      fill="#fff"
      height="15.27"
      transform="translate(-193.48 83.29) rotate(-19.65)"
      width="155.5"
      x="429.78"
      y="364.17"
    />
    <rect
      fill="#fff"
      height="15.27"
      transform="translate(-203.18 88.77) rotate(-19.65)"
      width="155.5"
      x="440.75"
      y="394.9"
    />
    <rect
      fill="#fff"
      height="15.27"
      transform="translate(-212.87 94.24) rotate(-19.65)"
      width="155.5"
      x="451.72"
      y="425.63"
    />
    <rect
      fill="#fff"
      height="15.27"
      transform="translate(-222.56 99.72) rotate(-19.65)"
      width="155.5"
      x="462.69"
      y="456.35"
    />
    <rect
      fill="#fff"
      height="15.27"
      transform="translate(-232.25 105.2) rotate(-19.65)"
      width="155.5"
      x="473.66"
      y="487.08"
    />
    <rect
      fill="#fff"
      height="40.26"
      transform="translate(-241.78 136.97) rotate(-19.65)"
      width="40.26"
      x="618.27"
      y="517.98"
    />
    <rect
      fill="url(#f0a282d0-9b08-452c-9a6e-ab0cad214b10)"
      height="402.63"
      transform="translate(-281.26 459.43) rotate(-59.28)"
      width="258.63"
      x="278.56"
      y="243.92"
    />
    <rect
      fill="#f1f1f4"
      height="390.14"
      transform="translate(-281.26 459.43) rotate(-59.28)"
      width="250.61"
      x="282.57"
      y="250.17"
    />
    <rect
      fill="#fff"
      height="16.66"
      transform="translate(-334.45 311.47) rotate(-59.28)"
      width="70.81"
      x="215.86"
      y="409.66"
    />
    <rect
      fill="#fff"
      height="15.27"
      transform="translate(-279.65 355.76) rotate(-59.28)"
      width="155.5"
      x="239.83"
      y="384.35"
    />
    <rect
      fill="#fff"
      height="15.27"
      transform="translate(-280.26 388.03) rotate(-59.28)"
      width="155.5"
      x="267.88"
      y="401.02"
    />
    <rect
      fill="#fff"
      height="15.27"
      transform="matrix(0.51, -0.86, 0.86, 0.51, -280.87, 420.3)"
      width="155.5"
      x="295.93"
      y="417.69"
    />
    <rect
      fill="#fff"
      height="15.27"
      transform="translate(-281.48 452.56) rotate(-59.28)"
      width="155.5"
      x="323.98"
      y="434.35"
    />
    <rect
      fill="#fff"
      height="15.27"
      transform="translate(-282.09 484.83) rotate(-59.28)"
      width="155.5"
      x="352.03"
      y="451.02"
    />
    <rect
      fill="#fff"
      height="15.27"
      transform="translate(-282.69 517.1) rotate(-59.28)"
      width="155.5"
      x="380.08"
      y="467.69"
    />
    <rect
      fill="#fff"
      height="40.26"
      transform="matrix(0.51, -0.86, 0.86, 0.51, -217.41, 587.69)"
      width="40.26"
      x="532.37"
      y="433.12"
    />
    <path
      d="M1056.2,236.09q0-.74-.15-1.41t-.26-1.55q-.28-1.52-.64-2.94-.18-.71-.37-1.39a37.43,37.43,0,0,0-7.51-14.29l-.6-.68q-.6-.66-1.19-1.25t-1.16-1.09c-.38-.34-.75-.65-1.11-.95-.71-.58-1.38-1.07-2-1.47s-.84-.55-1.19-.76a6.73,6.73,0,0,0-2.8-.91l-6.17-.6h0l-8.34-.82L992.6,194.35l-1.19.42a68.94,68.94,0,0,1-2.23-7.37,6.71,6.71,0,0,0,2.38-1.73,5.42,5.42,0,0,0,1.64-2.09c.76-1.74-.69-5.46-.4-7.58.48-3.41,2.26-6.71,3.71-9.8,3.1-6.64,5.36-13.83,5-21.12s-3.71-14.68-9.9-18.76c-3.2-2.11-7-3.24-10.29-5.16-2.59-1.5-4.87-3.45-7.34-5.14a42.38,42.38,0,0,0-41.53-2.95c-6.26,3.07-11.6,7.65-17.51,11.32s-12.87,6.51-19.78,5.42a4.38,4.38,0,0,0-.21.85l-.58-.07c-1.19,3.23,1.73,6.41,4.42,8.62,5.1,4.18,10.89,8.36,17.55,8.5,2.57.06,5.29-.48,7.63.57a6.83,6.83,0,0,1,1.42.88A32.8,32.8,0,0,0,935.8,182l-15.38-5.5s-.64.33-1.64.95l-21.37-14.13s-42.83-15.51-54.73,8.53,51.56,11.63,51.56,11.63l13.58,7.42a12.26,12.26,0,0,0,1.49,8.09l37,22.74c-7.48,2.29-19.77,6-22,6-3.17,0-11.9,3.1-17.45,15.51s-25.38,72.91-42.83,83-63.46,77.56-63.46,77.56l.21.53q-1.23.32-2.41.71c-11.51,3.72-19.25,11.57-23.92,17.92a7.6,7.6,0,0,0,5.36,12c18.16,2.28,28.08-6,32.85-12.32.31-.41.6-.81.87-1.2a6.42,6.42,0,0,0,4.48.2l22.21-17.84s-17.38,17-7.19,32.49l-.77,1.07a246.31,246.31,0,0,0-37.25,80.46s-9.52,7-10.31,34.9-10.31,72.91-10.31,72.91-6.35,53.52-2.38,69.81c0,0,.46.65,1.3,1.64-.3.35-.62.73-1,1.12-3.46,3.72-9.71,8.85-17,7.32-11.11-2.33-11.11,17.06,4.76,18.62,10.22,1,30.29,5.54,43.3,8.64a9.1,9.1,0,0,0,11.31-9.67c-.78-6.95-2.19-15.36-4.76-21.35-.16-.37-.32-.73-.49-1.09.47-.43.93-.88,1.4-1.36,0,0,0-34.13,5.55-43.44,0,0,15.07-70.58,14.28-88.42-.62-14,39.09-68.32,56.38-91.28l-.14-.87c4.42-5.86,7.22-9.46,7.22-9.46l13.48,84.54S914.07,569,922,579.06c0,0,34.11,64.38,38.07,84.54,3,15.29,9.2,24.33,12,27.81-.33.33-.67.66-1,1-3.61,3.29-8.94,6.59-15,5.33C945,695.4,945,714.79,960.87,716.34c10.22,1,30.29,5.54,43.3,8.64a9.1,9.1,0,0,0,11.31-9.67c-.9-8.07-2.67-18.11-6.09-24q-.43-.75-.9-1.41a8.38,8.38,0,0,0,3.15-2.21S991,638.78,991,625.59c0,0-8.73-50.42-38.07-69,0,0,2.78-63.05,11.13-98.15q.31-1.3.63-2.55c7.51-1.17,15.23-2.74,23.14-4.79l.79-23.27,4,18.62L1037,419.28s-.39-4.89-1.14-12.39c-.38-3.75-.84-8.15-1.4-12.92-.44-3.82-.95-7.87-1.5-12q-.21-1.55-.43-3.12c-.58-4.18-1.22-8.41-1.91-12.55q-.39-2.33-.8-4.61c-.36-2-.74-4-1.13-5.94q-.29-1.45-.6-2.86t-.62-2.76q-.31-1.35-.63-2.65l-.32-1.28q-.33-1.26-.66-2.46a44.17,44.17,0,0,1-1.61-10.17q-.08-2,0-4.1t.4-4.08q.14-1,.34-2a45.92,45.92,0,0,1,2.25-7.92q.74-1.93,1.66-3.81c1.44-2.93,3-6.11,4.56-9.46q1.19-2.51,2.4-5.13t2.44-5.32c7.72-17.1,15.34-36.16,17.38-48.67.21-1.32.37-2.56.45-3.73A24.72,24.72,0,0,0,1056.2,236.09Z"
      fill="url(#b45dc65a-d934-4006-b8a5-a3a1dfbcc07e)"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M923.71,185.16l-26.16-17.7s-41.55-15.39-53.09,8.46,50,11.54,50,11.54l26.16,14.62Z"
      fill="#f7bbc3"
      transform="translate(-98.02 -109)"
    />
    <rect
      fill="#f1f1f4"
      height="390.14"
      transform="translate(32.3 775.56) rotate(-57.57)"
      width="250.61"
      x="744.83"
      y="128.61"
    />
    <rect
      fill="#fff"
      height="16.66"
      transform="translate(-12.99 629.32) rotate(-57.57)"
      width="70.81"
      x="679"
      y="283.44"
    />
    <rect
      fill="#fff"
      height="15.27"
      transform="translate(38.38 674.79) rotate(-57.57)"
      width="155.5"
      x="703.72"
      y="260.13"
    />
    <rect
      fill="#fff"
      height="15.27"
      transform="translate(36.39 706.15) rotate(-57.57)"
      width="155.5"
      x="731.26"
      y="277.62"
    />
    <rect
      fill="#fff"
      height="15.27"
      transform="translate(34.39 737.51) rotate(-57.57)"
      width="155.5"
      x="758.8"
      y="295.12"
    />
    <rect
      fill="#fff"
      height="15.27"
      transform="matrix(0.54, -0.84, 0.84, 0.54, 32.39, 768.87)"
      width="155.5"
      x="786.34"
      y="312.62"
    />
    <rect
      fill="#fff"
      height="15.27"
      transform="translate(30.4 800.23) rotate(-57.57)"
      width="155.5"
      x="813.88"
      y="330.11"
    />
    <rect
      fill="#fff"
      height="15.27"
      transform="matrix(0.54, -0.84, 0.84, 0.54, 28.4, 831.59)"
      width="155.5"
      x="841.42"
      y="347.61"
    />
    <rect
      fill="#fff"
      height="40.26"
      transform="translate(88.83 903.09) rotate(-57.57)"
      width="40.26"
      x="994.33"
      y="315.87"
    />
    <path
      d="M1001.1,724.59c-12.62-3.08-32.09-7.58-42-8.57-15.39-1.54-15.39-20.77-4.62-18.46,5.84,1.25,11-2,14.51-5.29A34,34,0,0,0,972,689a8.89,8.89,0,0,1,5-3c5.77-1.26,17.78-3.16,25.17.82a10.87,10.87,0,0,1,4,4.36c3.32,5.89,5,15.84,5.91,23.85A8.9,8.9,0,0,1,1001.1,724.59Z"
      fill="#b77983"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M806.45,732.29c-12.62-3.08-32.09-7.58-42-8.57-15.39-1.54-15.39-20.77-4.62-18.46,7,1.52,13.11-3.58,16.46-7.26.41-.45.78-.88,1.1-1.28a8.89,8.89,0,0,1,5-3c5.77-1.26,17.78-3.16,25.17.82,2.16,1.17,3.89,3.73,5.27,7,2.49,5.94,3.86,14.28,4.62,21.17A8.9,8.9,0,0,1,806.45,732.29Z"
      fill="#b77983"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M812.8,701.52c-18.37,18.93-34.12-.35-36.51-3.53.41-.45.78-.88,1.1-1.28a8.89,8.89,0,0,1,5-3c5.77-1.26,17.78-3.16,25.17.82C809.69,695.65,811.42,698.21,812.8,701.52Z"
      opacity="0.1"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M1006.16,691.15c-8,5.44-34.75,4.1-34.75,4.1a26.36,26.36,0,0,1-2.42-3A34,34,0,0,0,972,689a8.89,8.89,0,0,1,5-3c5.77-1.26,17.78-3.16,25.17.82A10.87,10.87,0,0,1,1006.16,691.15Z"
      opacity="0.1"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M1007.57,687.56c-5.39,6.92-36.16,5.39-36.16,5.39s-9.23-9.23-13.08-29.24-36.93-83.86-36.93-83.86c-7.69-10-13.85-28.47-13.85-28.47l-13.08-83.86s-63.09,83.09-62.32,100.79S818.3,656,818.3,656c-5.39,9.23-5.39,43.08-5.39,43.08-20,20.77-36.93-3.85-36.93-3.85-3.85-16.16,2.31-69.24,2.31-69.24s9.23-44.62,10-72.32,10-34.62,10-34.62a246.78,246.78,0,0,1,36.13-79.81c4.65-6.66,7.72-10.21,7.72-10.21l124.64,14.62c-2,4-3.79,9.73-5.36,16.51-8.1,34.81-10.79,97.36-10.79,97.36C979.1,576,987.56,626,987.56,626,987.56,639.08,1007.57,687.56,1007.57,687.56Z"
      fill="#8499f0"
      transform="translate(-98.02 -109)"
    />
    <g opacity="0.05">
      <path
        d="M887.6,477.76,886,467.51s-63.09,83.09-62.32,100.79S809.84,656,809.84,656c-5.39,9.23-5.39,43.08-5.39,43.08-4.19,4.35-8.25,6.71-12,7.72,6.06,1.59,13.43.43,21.28-7.72,0,0,0-33.85,5.39-43.08,0,0,14.62-70,13.85-87.71C832.32,554.45,870.84,500.54,887.6,477.76Z"
        transform="translate(-98.02 -109)"
      />
      <path
        d="M988.33,626s-8.46-50-36.93-68.47c0,0,2.69-62.54,10.79-97.36,1.58-6.78,3.35-12.5,5.36-16.51L842.92,429s-.29.34-.82,1l116.23,13.63c-2,4-3.79,9.73-5.36,16.51-8.1,34.81-10.79,97.36-10.79,97.36C970.64,576,979.1,626,979.1,626c0,13.08,20,61.55,20,61.55-3.17,4.08-15.17,5.22-24.49,5.47,7.39.19,29.26.26,33.72-5.47C1008.34,687.56,988.33,639.08,988.33,626Z"
        transform="translate(-98.02 -109)"
      />
    </g>
    <path
      d="M819.07,418.28a27.86,27.86,0,0,1-3.65,6.37c-4.63,6.23-14.25,14.48-31.87,12.22a7.57,7.57,0,0,1-5.2-11.89c4.52-6.3,12-14.09,23.2-17.78a41.79,41.79,0,0,1,9.82-2Z"
      fill="#f7bbc3"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M981.55,203.11l-61.7-22.57s-17.7,9.23-10.77,22.31l60,37.7Z"
      fill="#d39999"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M981.55,203.11l-61.7-22.57s-17.7,9.23-10.77,22.31l60,37.7Z"
      opacity="0.1"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M983.72,165.92s-.77,36.16,15.39,48.47-46.93,19.23-46.93,19.23,10-36.93,0-56.16S983.72,165.92,983.72,165.92Z"
      fill="#f7bbc3"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M966.79,443.66c-2,4-3.79,9.73-5.36,16.51-74.41,11.36-126.2-19.59-126.2-19.59-.28-.45-.55-.89-.8-1.33,4.65-6.66,7.72-10.21,7.72-10.21Z"
      opacity="0.1"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M819.07,418.28a27.86,27.86,0,0,1-3.65,6.37c-7.12-1.18-12.82-14.8-13.87-17.46a41.79,41.79,0,0,1,9.82-2Z"
      opacity="0.1"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M989.87,198.23l-27.7,10-11.54,15.39s-23.85,7.69-26.93,7.69-11.54,3.08-16.93,15.39S882.16,319,865.23,329,803.68,406,803.68,406s7.69,20.77,16.93,17.7L842.15,406s-16.93,16.93-6.92,32.31c0,0,63.09,37.7,150,14.62l.77-23.08,3.85,18.46L1033,421.35s-3.86-49.66-10.81-74.94a45.66,45.66,0,0,1,3-31.84c11.17-23.28,28.41-62.16,26.31-76.34-2.48-16.71-11.92-24-15.52-26.16a6.43,6.43,0,0,0-2.71-.9l-14.08-1.41Z"
      fill="#d39999"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M942.55,275.56s-15.39,71.55-32.31,83.09-62.32,48.47-63.86,54.63"
      opacity="0.05"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M935.63,273.25s-15.39,71.55-32.31,83.09S841,404.81,839.46,411"
      fill="#d39999"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M950.25,223.24s53.09-17.7,68.47-13.08"
      opacity="0.1"
      transform="translate(-98.02 -109)"
    />
    <g opacity="0.05">
      <path
        d="M1025.11,314.58c11.17-23.28,28.41-62.16,26.31-76.34-2.48-16.71-11.92-24-15.52-26.16a6.43,6.43,0,0,0-2.71-.9l-6-.6a6.32,6.32,0,0,1,1.78.73c3.6,2.2,13,9.45,15.52,26.16,2.1,14.17-15.14,53.06-26.31,76.34a45.66,45.66,0,0,0-3,31.84c7,25.28,10.81,74.94,10.81,74.94l-37.1,23.19.94,4.51L1033,421.35s-3.86-49.66-10.81-74.94A45.66,45.66,0,0,1,1025.11,314.58Z"
        transform="translate(-98.02 -109)"
      />
      <polygon points="914.16 100.01 920.83 100.67 891.85 89.23 889.25 90.17 914.16 100.01" />
    </g>
    <path
      d="M935.63,347.88s23.85-13.08,31.54-10,36.16-.77,36.16-.77"
      opacity="0.05"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M981,175.54c-.88-7.71,2.69-6.54,2.69-6.54s-41.55-7.69-31.54,11.54c2.5,4.82,3.75,10.74,4.22,16.92h.39C968.38,197.47,975.11,184.56,981,175.54Z"
      opacity="0.05"
      transform="translate(-98.02 -109)"
    />
    <circle
      cx="858.77"
      cy="52.3"
      fill="#f7bbc3"
      r="33.08"
    />
    <path
      d="M992.89,171.09c3-6.58,5.2-13.72,4.83-21s-3.6-14.57-9.6-18.61c-3.1-2.09-6.76-3.21-10-5.11-2.51-1.49-4.73-3.42-7.12-5.1a40.33,40.33,0,0,0-40.28-2.93c-6.07,3-11.25,7.59-17,11.23s-12.48,6.45-19.19,5.37c-1.15,3.2,1.68,6.36,4.29,8.55,4.95,4.15,10.56,8.29,17,8.43,2.5.06,5.13-.48,7.4.57a10.62,10.62,0,0,1,3.78,3.51,68.76,68.76,0,0,1,7.85,13.31c.86,1.93,1.74,4,3.52,5.17,3,1.9,6.83.32,10.35.18,5.48-.21,10.4,3.23,14.46,6.93s7.91,7.9,13,9.85c3.82,1.45,11.46,1.4,13.41-3.17.73-1.72-.67-5.41-.38-7.52C989.75,177.42,991.49,174.16,992.89,171.09Z"
      opacity="0.1"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M993.66,170.32c3-6.58,5.2-13.72,4.83-21s-3.6-14.57-9.6-18.61c-3.1-2.09-6.76-3.21-10-5.11-2.51-1.49-4.73-3.42-7.12-5.1a40.33,40.33,0,0,0-40.28-2.93c-6.07,3-11.25,7.59-17,11.23s-12.48,6.45-19.19,5.37c-1.15,3.2,1.68,6.36,4.29,8.55,4.95,4.15,10.56,8.29,17,8.43,2.5.06,5.13-.48,7.4.57a10.62,10.62,0,0,1,3.78,3.51,68.76,68.76,0,0,1,7.85,13.31c.86,1.93,1.74,4,3.52,5.17,3,1.9,6.83.32,10.35.18,5.48-.21,10.4,3.23,14.46,6.93s7.91,7.9,13,9.85c3.82,1.45,11.46,1.4,13.41-3.17.73-1.72-.67-5.41-.38-7.52C990.52,176.66,992.26,173.39,993.66,170.32Z"
      fill="#9b6c7a"
      transform="translate(-98.02 -109)"
    />
    <polygon
      fill="currentColor"
      points="676.74 578.51 153.31 578.51 153.31 251.54 220.25 251.54 247.79 285.56 676.74 285.56 676.74 578.51"
    />
    <path
      d="M281,720.13s-22.57-4.51-28.59-10.53-33.1-16.55-36.11-9-40.62,33.1-15,37.62,60.18,6,67.71,3S281,720.13,281,720.13Z"
      fill="#a8a8a8"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M201.26,735.39c25.58,4.51,60.18,6,67.71,3,5.73-2.29,9.71-13.3,11.28-18.43l.75.16s-4.51,18.06-12,21.06-42.13,1.5-67.71-3c-7.38-1.3-9.49-4.36-8.7-8.24C193.19,732.48,195.76,734.42,201.26,735.39Z"
      opacity="0.2"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M747.38,761.49s-34.43-6.89-43.62-16.07-50.5-25.25-55.09-13.77-62,50.5-23,57.39,91.82,9.18,103.3,4.59S747.38,761.49,747.38,761.49Z"
      fill="#a8a8a8"
      transform="translate(-98.02 -109)"
    />
    <path
      d="M625.72,784.77c39,6.89,91.82,9.18,103.3,4.59,8.74-3.5,14.82-20.3,17.22-28.11l1.15.24S740.5,789,729,793.62s-64.28,2.3-103.3-4.59c-11.27-2-14.49-6.66-13.27-12.56C613.41,780.32,617.33,783.29,625.72,784.77Z"
      opacity="0.2"
      transform="translate(-98.02 -109)"
    />
    <rect
      height="20"
      opacity="0.1"
      width="116"
      x="351.98"
      y="405.02"
    />
  </svg>
</template>
